import { ModuleStructure } from "./module-structure";

export class CourseStructure {
	moduleStructures: ModuleStructure[];

	constructor() {
		this.moduleStructures = [];
	}
}
